<div id="db-wrapper" [ngClass]="{ 'toggled': isSidebarMenuToggled}">
  <app-sidebar
    [isMobile]="isMobile"
    [isMobileMenuClosed]="isMobileMenuClosed"
    [ngClass]="{
      'close-admin-mobile-menu': isMobileMenuClosed && isMobile,
      'z-1': !isMobile
    }"
    (mobileMenuCloseEvent)="isMobile && setSidebarMobileMenuToggled()"
    (toggleSidebarEvent)="!isMobile && setSidebarMenuToggled($event)"
  />

  <main
    [attr.id]="isMobile ? '' : 'page-content'"
    [ngClass]="{ 'overflow-hidden': !isMobileMenuClosed, 'white' : filterData}"
    class="w-100"
  >
    <div
      [class.mobile-admin-main]="isMobileAndMenuOpen"
      [class.rounded-top-5]="isMobileAndMenuOpen"
      [class.main-content-closed]="isMobileAndMenuClosed"
    >
      <app-header
        [isMobile]="isMobile"
        [isMobileMenuClosed]="isMobileAndMenuClosed"
        [pageTitle]="currentTitle"
        (mobileMenuCloseEvent)="isMobile && setSidebarMobileMenuToggled()"
        (toggleSidebarEvent)="!isMobile && setSidebarMenuToggled($event)"
        [isFilterPage]="filterData"
        (filterData)="handleFilterData($event)"
      />

      <div
        *ngIf="isMobile && !isMobileAndMenuClosed"
        class="overlay rounded-top-5"
        (click)="setSidebarMobileMenuToggled()"
      ></div>

      <app-root [ngClass]="{ 'rounded-top-5': isMobile && !isMobileMenuClosed }"/>
    </div>
  </main>
</div>
